<div (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)" (dragover)="dragOver($event)" (drop)="dropFile($event)">
  @if (showDropOverlay) {
    <div class="drop-overlay">
      <div class="drop-overlay-content">
        <span i18n>Drop file to attach document</span>
      </div>
    </div>
  }
@if (largeMode$ | async) {
  <div class="editor-container">
    <div class="flex flex-col">
      <div class="flex flex-col md:flex-row pb-4">
        <div class="flex-auto md:w-1/2 background pr-2">
          <mat-card appearance="raised">
            <mat-card-header>
              <mat-card-title i18n class="section-title">Shipper</mat-card-title>
            </mat-card-header>
            <!--<div i18n class="opacity-75 uppercase py-2 font-bold text-sm">Shipper</div>-->
            <mat-card-content>
              @if (quickQuote$ | async) {
                <app-quick-card-form [cardType]="cardTypes.SHIPPER"></app-quick-card-form>
              }
              @if (!(quickQuote$ | async)) {
                <app-card-form [cardType]="cardTypes.SHIPPER"></app-card-form>
              }
            </mat-card-content>
          </mat-card>
        </div>
        <div class="flex-auto md:w-1/2 background pl-2">
          <mat-card appearance="raised">
            <mat-card-header>
              <mat-card-title i18n class="section-title">Destination</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              @if (quickQuote$ | async) {
                <app-quick-card-form [cardType]="cardTypes.DESTINATION"
                ></app-quick-card-form>
              }
              @if (!(quickQuote$ | async)) {
                <app-card-form [cardType]="cardTypes.DESTINATION"></app-card-form>
              }
            </mat-card-content>
          </mat-card>
        </div>
      </div>
      @if (brokerDisplay$ | async) {
          <div class="flex flex-col md:flex-row pb-4">
              <div class="flex-auto md:w-1/2 background pr-2">
                  <mat-card appearance="raised">
                      <mat-card-header>
                          <mat-card-title i18n class="section-title">Sold-To</mat-card-title>
                      </mat-card-header>
                      <!--<div i18n class="opacity-75 uppercase py-2 font-bold text-sm">Shipper</div>-->
                      <mat-card-content>
                          @if (quickQuote$ | async) {
                              <app-quick-card-form [cardType]="cardTypes.SOLD_TO"></app-quick-card-form>
                          }
                          @if (!(quickQuote$ | async)) {
                              <app-card-form [cardType]="cardTypes.SOLD_TO"></app-card-form>
                          }
                      </mat-card-content>
                  </mat-card>
              </div>
              <div class="flex-auto md:w-1/2 background pl-2">
                  <mat-card appearance="raised">
                      <mat-card-header>
                          <mat-card-title i18n class="section-title">Broker</mat-card-title>
                      </mat-card-header>
                      <mat-card-content>
                          @if (quickQuote$ | async) {
                              <app-quick-card-form [cardType]="cardTypes.BROKER"
                              ></app-quick-card-form>
                          }
                          @if (!(quickQuote$ | async)) {
                              <app-card-form [cardType]="cardTypes.BROKER"></app-card-form>
                          }
                      </mat-card-content>
                  </mat-card>
              </div>
          </div>
      }
      @if (fullWidthPackages$ | async) {
        <div class="flex flex-col pb-4">
          <div class="flex flex-col grow">
            <mat-card appearance="raised">
              <mat-card-header>
                <mat-card-title i18n class="section-title">Package Details</mat-card-title>
              </mat-card-header>
              <app-shipment-packages></app-shipment-packages>
            </mat-card>
          </div>
        </div>
      }
      <div class="flex flex-col md:flex-row gap-4">
        @if (!(fullWidthPackages$ | async)) {
          <div class="flex-auto w-1/1 md:w-1/2 pb-4">
            <mat-card appearance="raised">
              <mat-card-header>
                <mat-card-title i18n class="section-title">Package Details</mat-card-title>
              </mat-card-header>
              <app-shipment-packages></app-shipment-packages>
            </mat-card>
          </div>
        }
        @if ((declaration$ | async) && !(quickQuote$ | async)) {
          <div class="flex-auto md:w-1/2 pb-4">
            <mat-card appearance="raised">
              <mat-card-header>
                <mat-card-title i18n class="section-title">Customs &amp; Commodities</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <app-shipment-international></app-shipment-international>
              </mat-card-content>
            </mat-card>
          </div>
        }

        @if (!(quickQuote$ | async)) {
          <div class="flex-auto w-1/1 md:w-1/2">
              @if (insuranceDisplay$ | async) {
                  <div class="pb-4">
                      <mat-card appearance="raised">
                          <mat-card-header>
                              <mat-card-title i18n class="section-title">Insurance</mat-card-title>
                          </mat-card-header>
                          <app-shipment-insurance></app-shipment-insurance>
                      </mat-card>
                  </div>
              }
            <mat-card appearance="raised">
              <mat-card-header>
                <mat-card-title i18n class="section-title">Options</mat-card-title>
              </mat-card-header>
              <app-shipment-options [courierOptionDefinitions]="courierOptionDefinitions$ | async"
              [referenceDefinitions]="referenceDefinitions$ | async"></app-shipment-options>
            </mat-card>
            @if ((documents$ | async)?.length) {
              <div class="pt-4">
                <mat-card appearance="raised">
                  <mat-card-header>
                    <mat-card-title i18n class="section-title">Documents</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <app-shipment-documents></app-shipment-documents>
                  </mat-card-content>
                </mat-card>
              </div>
            }
            <div class="pt-4">
              <mat-card appearance="raised" class="pb-4">
                <mat-card-header>
                  <mat-card-title i18n class="section-title">References</mat-card-title>
                </mat-card-header>
                <app-shipment-references [referenceDefinitions]="referenceDefinitions$ | async"></app-shipment-references>
              </mat-card>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}

@if (!(largeMode$ | async)) {
  <div class="shipment-editor p-4">
    <mat-accordion>
      <mat-expansion-panel #shipperPanel>
        <mat-expansion-panel-header collapsedHeight="64px">
          <mat-panel-title>Shipper</mat-panel-title>
          @if (!shipperPanel.expanded && !!(shipperError$ | async)) {
            <mat-panel-description class="warn">{{ shipperError$ | async }}</mat-panel-description>
          }
          @if (!shipperPanel.expanded && !(shipperError$ | async)) {
            <mat-panel-description >{{ shipperSummary$ | async }}</mat-panel-description>
          }
        </mat-expansion-panel-header>
        @if (!(quickQuote$ | async)) {
          <app-card-form [cardType]="cardTypes.SHIPPER"></app-card-form>
        }
      </mat-expansion-panel>
      <mat-expansion-panel #destinationPanel>
        <mat-expansion-panel-header collapsedHeight="64px">
          <mat-panel-title>Destination</mat-panel-title>
          @if (!destinationPanel.expanded && !!(destinationError$ | async)) {
            <mat-panel-description class="warn">{{ destinationError$ | async }}</mat-panel-description>
          }
          @if (!destinationPanel.expanded && !(destinationError$ | async)) {
            <mat-panel-description>{{ destinationSummary$ | async }}</mat-panel-description>
          }
        </mat-expansion-panel-header>
        @if (!(quickQuote$ | async)) {
          <app-card-form [cardType]="cardTypes.DESTINATION"></app-card-form>
        }
      </mat-expansion-panel>
        @if (brokerDisplay$ | async) {
            <mat-expansion-panel #soldToPanel>
                <mat-expansion-panel-header collapsedHeight="64px">
                    <mat-panel-title>Sold-To</mat-panel-title>
                    @if (!soldToPanel.expanded && !!(soldToError$ | async)) {
                        <mat-panel-description class="warn">{{ soldToError$ | async }}</mat-panel-description>
                    }
                    @if (!soldToPanel.expanded && !(soldToError$ | async)) {
                        <mat-panel-description>{{ soldToSummary$ | async }}</mat-panel-description>
                    }
                </mat-expansion-panel-header>
                @if (!(quickQuote$ | async)) {
                    <app-card-form [cardType]="cardTypes.SOLD_TO"></app-card-form>
                }
            </mat-expansion-panel>
            <mat-expansion-panel #brokerPanel>
                <mat-expansion-panel-header collapsedHeight="64px">
                    <mat-panel-title>Broker</mat-panel-title>
                    @if (!brokerPanel.expanded && !!(brokerError$ | async)) {
                        <mat-panel-description class="warn">{{ brokerError$ | async }}</mat-panel-description>
                    }
                    @if (!brokerPanel.expanded && !(brokerError$ | async)) {
                        <mat-panel-description>{{ brokerSummary$ | async }}</mat-panel-description>
                    }
                </mat-expansion-panel-header>
                @if (!(quickQuote$ | async)) {
                    <app-card-form [cardType]="cardTypes.BROKER"></app-card-form>
                }
            </mat-expansion-panel>
        }
      <mat-expansion-panel #packagesPanel class="full-width-panel">
        <mat-expansion-panel-header collapsedHeight="64px">
          <mat-panel-title>Packages</mat-panel-title>
          @if (!packagesPanel.expanded) {
            <mat-panel-description>{{ packageSummary$ | async }}</mat-panel-description>
          }
        </mat-expansion-panel-header>
        <app-shipment-packages class="expansion-packages"></app-shipment-packages>
      </mat-expansion-panel>
      <mat-expansion-panel #optionsPanel class="full-width-panel">
        <mat-expansion-panel-header collapsedHeight="64px">
          <mat-panel-title>Options</mat-panel-title>
          @if (!optionsPanel.expanded) {
            <mat-panel-description>{{ optionSummary$ | async }}</mat-panel-description>
          }
        </mat-expansion-panel-header>
        <app-shipment-options [courierOptionDefinitions]="courierOptionDefinitions$ | async"
        [referenceDefinitions]="referenceDefinitions$ | async"></app-shipment-options>
      </mat-expansion-panel>
      @if ((documents$ | async)?.length) {
        <mat-expansion-panel #documentsPanel class="full-width-panel">
          <mat-expansion-panel-header collapsedHeight="64px">
            <mat-panel-title i18n>Documents</mat-panel-title>
            @if (!documentsPanel.expanded) {
              <mat-panel-description>{{ documentsSummary$ | async }}</mat-panel-description>
            }
          </mat-expansion-panel-header>
          <div class="px-4">
            <app-shipment-documents></app-shipment-documents>
          </div>
        </mat-expansion-panel>
      }
        @if (insuranceDisplay$ | async) {
            <mat-expansion-panel #insurancePanel class="full-width-panel">
                <mat-expansion-panel-header collapsedHeight="64px">
                    <mat-panel-title>Insurance</mat-panel-title>
                    @if (!insurancePanel.expanded) {
                        <mat-panel-description>{{ insuranceSummary$ | async }}</mat-panel-description>
                    }
                </mat-expansion-panel-header>
                <app-shipment-insurance></app-shipment-insurance>
            </mat-expansion-panel>
        }
      @if (declaration$ | async) {
        <mat-expansion-panel #internationalPanel>
          <mat-expansion-panel-header collapsedHeight="64px">
            <mat-panel-title>International</mat-panel-title>
            @if (!internationalPanel.expanded) {
              <mat-panel-description>{{ internationalSummary$ | async }}</mat-panel-description>
            }
          </mat-expansion-panel-header>
          <app-shipment-international></app-shipment-international>
        </mat-expansion-panel>
      }
      <mat-expansion-panel #referencesPanel class="full-width-panel">
        <mat-expansion-panel-header collapsedHeight="64px">
          <mat-panel-title>References</mat-panel-title>
          @if (!referencesPanel.expanded) {
            <mat-panel-description>{{ referencesSummary$ | async }}</mat-panel-description>
          }
        </mat-expansion-panel-header>
        <app-shipment-references></app-shipment-references>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
}

<div class="flex justify-end pr-4 m b-4">
    <button mat-raised-button (click)="startQuoting()">Start Quoting</button>
</div>
</div>